import {
  IonModal,
  IonLabel,
  IonTextarea,
  IonButton,
  IonAlert,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { ERROR } from "../../../../../../constants/errorMessage.constants";
import { utilService } from "../../../../../../services/utilService";
import {
  SendPrimaryMdSmsReq,
  SendPrimaryMdSmsRes,
} from "../../../../StatusBoard.model";
import "./PrimaryMdPopup.scss";
import { useToast } from "@agney/ir-toast";
import { statusBoardService } from "../../../../StatusBoard.service";
import { CONSTANTS } from "../../../../../../constants";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
  primaryMdData: any;
  unitDetailsData: any;
}

const PrimaryMdPopup: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const Toast = useToast();

  var [isApiCalling, setIsApiCalling] = useState(false);
  var [sendSmsData, setSendSmsData]: any = useState([]);
  var [currentErrorMessage, setCurrentErrorMessage]: any = useState();
  var [isShowAlert, setIsShowAlert] = useState(false);

  const [textData, setTextData] = useState("");

  var [disableSendButton, setDisableSendButton] = useState(true);
  var [isInputEmpty, setIsInputEmpty] = useState(true);

  var [messageType, setMessageType]: any = useState();

  useEffect(() => {
    disableMessageSendButton();
  }, [isInputEmpty]);

  async function sendSms(params: SendPrimaryMdSmsReq) {
    setIsApiCalling(true);
    const respPrimaryMdSendMessageResult: SendPrimaryMdSmsRes =
      await statusBoardService.primaryMdMessage(params);
    if (respPrimaryMdSendMessageResult.isSuccess) {
      setSendSmsData(respPrimaryMdSendMessageResult);
      showApiResponse(respPrimaryMdSendMessageResult);
    } else {
     Toast.error(t("smsFailed"));
    }
    setIsApiCalling(false);
  }

  const showApiResponse = (sendSmsData: any) => {
    if (sendSmsData.status !== 200) {
      setCurrentErrorMessage(ERROR.sendSms.SMS_SENDING_FAILED);
      setIsShowAlert(true);
    } else if (sendSmsData.status === 200) {
      Toast.success(sendSmsData.message);
    }
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("Message");
    setIsInputEmpty(isWhitespace);
  };

  const disableMessageSendButton = () => {
    if (isInputEmpty) {
      setDisableSendButton(true);
    } else {
      setDisableSendButton(false);
    }
  };

  const setNurseName = (nurseName: any, type: any) => {
    if (type == "firstName") {
      var firstName = nurseName.list_nurse
        ? nurseName.list_nurse[0].first_name
        : "";
      return firstName;
    } else if (type == "lastName")
      var lastName = nurseName.list_nurse
        ? nurseName.list_nurse[0].last_name
        : "";
    return lastName;
  };

  const getMessageContent = (type: any) => {
    messageType = type;
    let text: String = "";
    switch (messageType) {
      case CONSTANTS.PAGER_TYPE.NURSE:
        const receiverNurseName =
          type === CONSTANTS.PAGER_TYPE.NURSE
            ? "Nurse " +
              setNurseName(props.primaryMdData.nurse, "firstName") +
              setNurseName(props.primaryMdData.nurse, "lastName")
            : "";
       text = t("pleaseCallPatient", {
  receiver: receiverNurseName,
  patient: props.primaryMdData.patient.value,
});
        break;
      case CONSTANTS.PAGER_TYPE.UNIT:
        const receiverDataName =
          type === CONSTANTS.PAGER_TYPE.UNIT
            ? "Unit " + props.unitDetailsData[0].unit.unitName
            : "";
       text = t("pleaseCallPatient", {
  receiver: receiverDataName,
  patient: props.primaryMdData.patient.value,
});
        break;
      case CONSTANTS.PAGER_TYPE.NONE:
        text = textData;
    }
    const params = getParams(text);
    if (params && params.mobile_number) {
      sendSms(params);
    } else {
      Toast.error(t("noContact"));
    }
  };

  const getParams = (text: any) => {
    let pager_num = "";
    if (
      messageType === CONSTANTS.PAGER_TYPE.NURSE ||
      messageType === CONSTANTS.PAGER_TYPE.UNIT
    ) {
      pager_num = props.primaryMdData.primarymd
        ? props.primaryMdData.primarymd.prymary_md_pager
        : "";
    } else {
      pager_num = props.primaryMdData.primarymd
        ? props.primaryMdData.primarymd.mobile_number
        : "";
    }
    return {
      to:
        props.primaryMdData.primarymd && props.primaryMdData.primarymd.guid
          ? props.primaryMdData.primarymd.guid
          : "",
      from: utilService.getLoggedUserGuid(),
      text,
      type: "sms",
      mobile_number: Number(pager_num),
      reg_code: utilService.getNetwork(),
    };
  };

  const mapDoctorName = () => {
    if (_.isEmpty(props.primaryMdData)) {
      return "Doctors Name";
    } else {
      return (
        props.primaryMdData.primarymd.first_name +
        " " +
        props.primaryMdData.primarymd.last_name
      );
    }
  };

  return (
    <div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        message={currentErrorMessage}
        buttons={[
          {
             text: t("ok"),
            handler: () => {
              setIsShowAlert(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="primary-md-modal"
      >
        <div className="primary-md-container">
          <span className="primary-md-heading">{mapDoctorName()}</span>
          <IonLabel
            className="close icon-close"
            onClick={() => {
              props.onCancel();
              setIsInputEmpty(true);
              setTextData("");
            }}
          ></IonLabel>
          <div className="primary-md-options">
            <div
              className="primary-md-border"
              onClick={() => {
                getMessageContent(CONSTANTS.PAGER_TYPE?.NURSE);
              }}
            >
              {t("pageToNurse")}
            </div>
            <div
              className="primary-md-border"
              onClick={() => {
                getMessageContent(CONSTANTS.PAGER_TYPE?.UNIT);
              }}
            >
             {t("pageToUnit")}
            </div>
          </div>
          <div className="primary-md-form">
            <div className="message-header">{t("message")}</div>
            <IonTextarea
              className="text-area-wrap"
              value={textData}
              onIonChange={(event) => {
                checkIfInputEmpty();
                setTextData(event.detail.value!);
              }}
              maxlength={250}
              placeholder={t("messagePlaceholder")}
              autoCorrect="off"
            ></IonTextarea>
          </div>
          <div className="send-message">
            <IonButton
              className="button primary-btn  btn-curved"
              onClick={() => {
                props.onCancel();
                setTextData("");
                getMessageContent(CONSTANTS.PAGER_TYPE?.NONE);
              }}
            >
              {" "}
               {t("sendMessage")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </div>
  );
};
export default PrimaryMdPopup;
